const mock = {
    "results": {
      "score": 3,
      "maxScore": 10
    },
    "submissionDate": "2024-09-04T22:11:41.9100414+00:00",
    "passed": true,
    "sealed": true,
    "questions": [
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "b846fdb1-7962-4aa6-b47f-15579edf0d88",
        "type": "SingleChoice",
        "content": "During the check-in the front desk agent must confirm the method of payment and offer to send the invoice to the guest’s email.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "0c184423-732f-4db3-8c8f-965f31f6cf7f",
        "type": "SingleChoice",
        "content": "If standing in a queue, an attempt to acknowledge the guest should be made in a timely manner.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "37f36c0c-0f46-472f-8b99-c066700cead8",
        "type": "MultiChoice",
        "content": "What should frond desk agent do when need to decline the guest’s request?",
        "options": [
          {
            "id": 0,
            "value": "Offer alternative option"
          },
          {
            "id": 1,
            "value": "Tell him/her to ask anyone else"
          },
          {
            "id": 2,
            "value": "Say ‘’No’’ when the request cannot be completed"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "16b64eaf-736f-4864-ba29-7c39839271ef",
        "type": "SingleChoice",
        "content": "Warm welcome and the nice greeting can make the guest have the first good impression in the beginning of the stay.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "27e3a7ac-d5e3-4ee3-8100-5d8e9af4b09a",
        "type": "MultiChoice",
        "content": "How should front desk agent answer the guest when he/she needs late check out but the room is already booked?",
        "options": [
          {
            "id": 0,
            "value": "Mr/Ms …, I am sorry but I am not able to provide late check-out."
          },
          {
            "id": 1,
            "value": "Mr/Ms …, I am not able to provide late check-out as the hotel is fully booked, we can try to find another hotel for you."
          },
          {
            "id": 2,
            "value": "Mr/Ms …, I am not able to provide late check-out due to high occupancy and as your room is upon arrival. Though I am happy to store your luggage till required time/suggest you to use our restaurant or lobby."
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "290858f3-e5d0-479f-9bfd-25ecc8d359b7",
        "type": "SingleChoice",
        "content": "Why is allowing the guest to enter/exit the elevator first considered a luxury service?",
        "options": [
          {
            "id": 0,
            "value": "It saves time"
          },
          {
            "id": 1,
            "value": "It's a safety requirement"
          },
          {
            "id": 2,
            "value": "It emphasizes guest priority"
          },
          {
            "id": 3,
            "value": "It prevents overcrowding"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "d7cc3525-dede-4beb-b16b-3eaf51b445cf",
        "type": "MultiChoice",
        "content": "What is one responsibility of a front desk agent when seeing a guest waiting in a queue?",
        "options": [
          {
            "id": 0,
            "value": "Ignore them until they approach the desk"
          },
          {
            "id": 1,
            "value": "Ask them to leave if they're taking too long"
          },
          {
            "id": 2,
            "value": "Attempt to acknowledge them in a timely manner"
          },
          {
            "id": 3,
            "value": "Play music to distract them"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "3bb06314-72d4-495c-9dd6-088e0c5e0a53",
        "type": "SingleChoice",
        "content": "What should an attendant do after resolving a guest's issue to maintain a positive relationship?",
        "options": [
          {
            "id": 0,
            "value": "Apologize repeatedly"
          },
          {
            "id": 1,
            "value": "Assume the issue is resolved and move on"
          },
          {
            "id": 2,
            "value": "Check with the guest regularly to ensure satisfaction"
          },
          {
            "id": 3,
            "value": "Avoid any further communication with the guest"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "caa2d5e5-28eb-46bf-89cb-eccca37d63cd",
        "type": "SingleChoice",
        "content": "What is a key aspect of active listening?",
        "options": [
          {
            "id": 0,
            "value": "Demonstrating empathy and understanding"
          },
          {
            "id": 1,
            "value": "Interrupting to offer solutions"
          },
          {
            "id": 2,
            "value": "Apologizing profusely"
          },
          {
            "id": 3,
            "value": "Avoiding eye contact with the guest"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "4039c6da-2c29-4675-b687-07acf607b1c7",
        "type": "SingleChoice",
        "content": "It is not obligatory to recognize all Marriott Bonvoy members during their check in.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      }
    ],
    "answers": [
      {
        "id": "b846fdb1-7962-4aa6-b47f-15579edf0d88",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "0c184423-732f-4db3-8c8f-965f31f6cf7f",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "37f36c0c-0f46-472f-8b99-c066700cead8",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "16b64eaf-736f-4864-ba29-7c39839271ef",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "27e3a7ac-d5e3-4ee3-8100-5d8e9af4b09a",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "290858f3-e5d0-479f-9bfd-25ecc8d359b7",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "d7cc3525-dede-4beb-b16b-3eaf51b445cf",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "3bb06314-72d4-495c-9dd6-088e0c5e0a53",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "caa2d5e5-28eb-46bf-89cb-eccca37d63cd",
        "choices": [
          0
        ],
        "isCorrect": true
      },
      {
        "id": "4039c6da-2c29-4675-b687-07acf607b1c7",
        "choices": [
          0
        ],
        "isCorrect": true
      }
    ],
    "startsAt": "2024-09-03T22:11:41.9100407+00:00",
    "endsAt": "2024-09-05T22:11:41.9100413+00:00"
  }

export default mock;